<div>

  <div class="mb-5x">
    <h2
      class="mb-3x">{{ 'COMMON_UI.FRAGEBOGEN.UMSATZSTEUER.TITEL' | translate }}
    </h2>

    <common-ui-anmeldung-abfuehrung-ust
      [(data)]="data" [readonly]="readonly"></common-ui-anmeldung-abfuehrung-ust>

  </div>

</div>
